<template>
    <div class="w-100">
        <main role="main" class="background-employer-dashboard pt-sm-3">
            <div class="container">
                <header-size-one :title="Lang.get('employeedashboard::pages/bookings/index.title')"
                                 :subtitle="Lang.get('employeedashboard::pages/bookings/index.subtitle') "/>
                <div class="row mt-5">
                    <div class="col-12 mb-4">
                        <flash-messages />
                        <div class="card h-100 border-radius-8 shadow">
                            <div class="card-body px-0 pb-4 pt-2">
                                <ul class="nav nav-tabs flex-nowrap px-3 my-3" id="bookingTab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link font-poppins font-size-14 color-blue"
                                           :class="{active : form.status === 'all'}"
                                           id="all-tab"
                                           data-toggle="tab"
                                           href="#all"
                                           role="tab"
                                           aria-controls="home"
                                           :aria-selected="{true : form.status === 'all'}"
                                           @click="reset">
                                            {{ Lang.get('employeedashboard::pages/bookings/index.tabs.all') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link font-poppins font-size-14 color-blue"
                                           :class="{active : form.status === 'open'}"
                                           data-toggle="tab"
                                           href="#all"
                                           role="tab"
                                           aria-controls="home"
                                           :aria-selected="{true : form.status === 'open'}"
                                           @click="open">
                                            {{ Lang.get('employeedashboard::pages/bookings/index.tabs.open') }}
                                            ({{ totalOpenBookings }})
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link font-poppins font-size-14 color-red"
                                           :class="{active : form.status === 'cancelled'}"
                                           data-toggle="tab" href="#all" role="tab" aria-controls="home"
                                           :aria-selected="{true : form.status === 'cancelled'}"
                                           @click="cancelled">
                                            {{ Lang.get('employeedashboard::pages/bookings/index.tabs.cancelled') }}
                                            ({{ totalCancelledBookings }})
                                        </a>
                                    </li>
                                </ul>
                                <div class="tab-content ml-0" id="bookingTabContent">
                                    <div class="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
                                        <div class="form-group input-group px-4 py-4 m-0 border-bottom">
                                            <input type="text" v-model="form.search"
                                                   class="form-control form-control-lg my-2 input-search font-poppins color-blue"
                                                   id="search"
                                                   :placeholder="Lang.get('employeedashboard::pages/bookings/index.search_an_booking')"
                                                   autocomplete="off">
                                        </div>
                                        <BookingAccordion :bookings="bookings" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'

import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/Search'
import throttle from 'lodash/throttle'
import SyncStatus from "@/Shared/SyncStatus";
import HeaderSizeOne from "@/Shared/HeaderSizeOne";
import BookingAccordion from "@/Shared/BookingAccordion/BookingAccordion";
import FlashMessages from "@/Shared/FlashMessages";

export default {
    metaInfo: { title: Lang.get('employeedashboard::pages/bookings/index.title') },
    layout: Layout,
    components: {
        BookingAccordion,
        HeaderSizeOne,
        SearchFilter,
        SyncStatus,
        FlashMessages,
    },
    props: {
        bookings: Object,
        totalCompletedBookings: Number,
        totalOpenBookings: Number,
        totalCancelledBookings: Number,
        filters: Object,
        errors: Object,
        sync: Object
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                status: this.filters.status,
            },
        }
    },
    watch: {
        form: {
            handler: throttle(function() {
                let query = pickBy(this.form)
                this.$inertia.get(route('nl.employeedashboard.bookings.overview'), Object.keys(query).length ? query : '', {
                    preserveState: true,
                    preserveScroll: false,
                    replace: true,
                    only: [],
                })
            }, 150),
            deep: true,
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null);
            this.form.status = 'all';
        },

        open() {
            this.form.status = 'open';
        },

        cancelled() {
            this.form.status = 'cancelled';
        },
    },
}
</script>
